import api from '../../plugins/api';

const downloadStockReport = (reportId) => {
  return api.get('/api/crm/cars/stockReport/download/' + reportId, {}, { responseType: 'blob' });
};

export default downloadStockReport;
